<template>
  <div>
    <p>{{ title }}</p>
      <draggable class="inner" :list="value" group="notes">
      <service-card
        class="list-group-item"
        v-for="element in value"
        :key="`${titlelc}-${element.id}`"
        :card="element"
        :all="all"
        @editNote="editNote"
        @showNote="showNote"
      >
      </service-card>
    </draggable>

  </div>
</template>

<script>
// @ is an alias to /src
import { ServiceCard } from "./";
import draggable from "vuedraggable";
export default {
  name: "UserServiceCol",
  props: {
    value: Array,
    title: String,
    all: Array
  },
  watch: {
    value: {
      handler: function (val) {
         this.$emit("input", val);
      },
      deep: true
    }
  },
  computed: {
    titlelc() {
      return this.title.toLowerCase()
    }
  },
  components: {
    ServiceCard,
    draggable,
  },
  methods: {
    editNote($event) {
      this.$emit('editNote', $event)
    },
     showNote($event) {
      this.$emit('showNote', $event)
    }
  }
};
</script>
